import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { NotACashGrabSection } from '../components/NotACashGrabSection';
import { ChillsSection } from '../components/ChillsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { AverageRatingSection } from '../components/AverageRatingSection';
import { TestimonialsGridSection } from '../components/TestimonialsGridSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SocialProofNotification } from '../components/SocialProofNotification';
export const LandingV1 = () => <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-648">
    <Header data-id="element-649" />
    <main data-id="element-650">
      <HeroSection data-id="element-651" />
      <NotACashGrabSection data-id="element-652" />
      <ChillsSection data-id="element-653" />
      <WhatsInsideSection data-id="element-654" />
      <SocialProofSection data-id="element-655" />
      <PricingSection data-id="element-656" />
      <AverageRatingSection data-id="element-657" />
      <TestimonialsGridSection data-id="element-658" />
      <UrgencySection data-id="element-659" />
      <FAQSection data-id="element-660" />
    </main>
    <Footer data-id="element-661" />
    <SocialProofNotification data-id="element-662" />
  </div>;